import CardDashboard from './card-dashboard';

export default CardDashboard;